import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../style.css';
const skeletonBaseProps = {
    width: '100%',
    height: '100%',
    baseColor: 'white',
};
const PageSkeleton = () => {
    return (React.createElement("div", { className: 'user-info full-height' },
        React.createElement("div", { className: 'container content' },
            React.createElement("div", { className: 'conq-flag-container' },
                React.createElement("div", { className: 'conq-flag' },
                    React.createElement(Skeleton, { width: '80px', height: '100%', baseColor: 'white' }))),
            React.createElement("div", { className: 'header' },
                React.createElement("div", { className: 'user-avatar' },
                    React.createElement(Skeleton, { ...skeletonBaseProps, circle: true })),
                React.createElement("div", null,
                    React.createElement("p", { className: 'user-name' },
                        React.createElement(Skeleton, { ...skeletonBaseProps, style: { marginBottom: '15px' } })),
                    React.createElement("p", { className: 'date' },
                        React.createElement(Skeleton, { width: '300px', baseColor: 'white' })))),
            React.createElement("div", { className: 'blocks-container' },
                React.createElement("div", { className: 'block-mission' },
                    React.createElement(Skeleton, { ...skeletonBaseProps, style: { minHeight: '200px' } })),
                React.createElement("div", { className: 'block-stats' },
                    React.createElement(Skeleton, { ...skeletonBaseProps, style: { minHeight: '200px' } })),
                React.createElement("div", { className: 'block-distance' },
                    React.createElement(Skeleton, { ...skeletonBaseProps, style: { minHeight: '128px' } })),
                React.createElement("div", { className: 'block-map' },
                    React.createElement(Skeleton, { ...skeletonBaseProps, style: { minHeight: '200px' } }))))));
};
export { PageSkeleton };
